import Base64 from "./Base64";

export function uatob(str) {
  try {
    return decodeURIComponent(escape(window.atob(str)));
  } catch (err) {
    return Base64.decode(str);
  }
}
